/*
	El nombre del plantel, en tres tallas.

	En la barra de arriba "Washington Academy Monterrey" no cabe siempre, y
	recortarlo con puntos suspensivos deja cosas como "Washington Academy Mo",
	que no dice nada. Esteban pidio (2026-09-16) que en vez de cortarse se
	abrevie: el nombre completo cuando cabe, "WA Monterrey" cuando aprieta, y las
	siglas del plantel cuando la pantalla ya es de telefono.

	Las siglas son las que usa la casa (las mismas del nombre de las facturas),
	no el campo "code" de la base, que dice otra cosa.
*/

const SIGLAS : {[clave : string] : string} =
{
	"monterrey"       : "MTY",
	"torreon"         : "TRC",
	"tegucigalpa"     : "TGU",
	"san pedro sula"  : "SPS",
	"san salvador"    : "SAL",
	"online"          : "ONL",
	"entrenamiento"   : "ENT"
}

const sinAcentos = (valor : string) : string =>
	valor.normalize("NFD").replace(/[̀-ͯ]/g, "")

/** Lo que queda al quitarle "Washington Academy": la ciudad. */
export const ciudadDelPlantel = (nombre : string | null | undefined) : string =>
	String(nombre || "").replace(/washington\s+academy/i, "").trim()

/** "Washington Academy Monterrey" -> "WA Monterrey". */
export const plantelMedio = (nombre : string | null | undefined) : string =>
{
	const ciudad = ciudadDelPlantel(nombre)

	return ciudad === "" ? String(nombre || "") : "WA " + ciudad
}

/** "Washington Academy Monterrey" -> "MTY". Si no se reconoce, las iniciales. */
export const plantelSiglas = (nombre : string | null | undefined) : string =>
{
	const ciudad = sinAcentos(ciudadDelPlantel(nombre)).toLowerCase()

	if(SIGLAS[ciudad])
	{
		return SIGLAS[ciudad]
	}

	//Un plantel nuevo todavia sin siglas: se arman con las iniciales de la ciudad.
	const iniciales = ciudad
		.split(/\s+/)
		.filter(Boolean)
		.map(palabra => palabra[0])
		.join("")
		.toUpperCase()

	return iniciales === "" ? String(nombre || "") : iniciales.slice(0, 3)
}
